module.exports = __webpack_public_path__ + "img/close.091a88e3.svg";